import React from "react"
import { Alert, Button } from "antd"

interface RunOnLoadBannerProps {
  /** runOnLoadFailureText of the last open, or null. */
  failure: string | null
  /**
   * Whether the failure names a script ("Run on load stopped at ..."). False
   * when the list itself failed ("Run on load failed: ..."), so no script is
   * there to fix.
   */
  namesScript: boolean
  withoutEdits: boolean
  onReload: () => void
  onTurnEditsOn: () => void
}

/** Says when Run on load stopped part way, or when this session shows the data without edits. */
const RunOnLoadBanner: React.FC<RunOnLoadBannerProps> = ({
  failure,
  namesScript,
  withoutEdits,
  onReload,
  onTurnEditsOn,
}) => {
  if (withoutEdits)
    return (
      <Alert
        className="mx-2 mb-2"
        type="info"
        showIcon
        message="Without edits: this session shows the data as imported. Run on load is off."
        action={
          <Button size="small" onClick={onTurnEditsOn}>
            Turn edits back on
          </Button>
        }
      />
    )
  if (failure)
    return (
      <Alert
        className="mx-2 mb-2"
        type="error"
        showIcon
        message={failure}
        description={
          namesScript
            ? "The scripts before it are applied. Fix the script, save it, then reload the data."
            : "Fix the Run on load list, then reload the data."
        }
        action={
          <Button size="small" onClick={onReload}>
            Reload data
          </Button>
        }
      />
    )
  return null
}

export default RunOnLoadBanner
